export default "__VITE_ASSET__CrKEIU5S__";